import { Box, Button, Modal, Typography } from "@mui/material";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";
import { useAuthContext } from "../../hooks/Auth";

const NotEnoughCredits = () => {
  const { selectedApp, isNotEnoughOpen, setIsNotEnoughOpen } =
    useActividadesContext();
  const { user } = useAuthContext();
  return (
    <Modal
      open={isNotEnoughOpen}
      onClose={() => setIsNotEnoughOpen(false)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component={"div"}
        sx={{
          width: 550,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          alignItems:"center"
        }}
      >
        <Typography component={"h3"} sx={{ fontSize: "20px", fontWeight: 600 }}>
          ¡Créditos insuficientes!
        </Typography>
        <Typography component={"p"}>
          Sus créditos mensuales disponibles <b>({user?.creditosDisponibles})</b> no
          alcanzan para usar esta app: <b>{selectedApp?.valor_creditos}</b>.
            <br/>
            <br/>
          Contacte al administrador de organización para extender su plan mensual.
        </Typography>
        <Box
          sx={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            gap: 3,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setIsNotEnoughOpen(false)}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Entendido
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NotEnoughCredits;
